import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HookHandlerClass;
function HookHandler() {
  if (HookHandlerClass === VOID) {
    class $ {
      constructor(hook, handler) {
        this.n5u_1 = hook;
        this.o5u_1 = handler;
      }
      b5h(client) {
        this.n5u_1.q5m(client, this.o5u_1);
      }
    }
    initMetadataForClass($, 'HookHandler');
    HookHandlerClass = $;
  }
  return HookHandlerClass;
}
//region block: exports
export {
  HookHandler as HookHandler356pvj77mag23,
};
//endregion

//# sourceMappingURL=ClientHook.mjs.map
